import { render, staticRenderFns } from "./ZTitle.vue?vue&type=template&id=4efdfeea&scoped=true"
import script from "./ZTitle.vue?vue&type=script&lang=js"
export * from "./ZTitle.vue?vue&type=script&lang=js"
import style0 from "./ZTitle.vue?vue&type=style&index=0&id=4efdfeea&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4efdfeea",
  null
  
)

export default component.exports